// cspell:words lezer
// eslint-disable-next-line id-length
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export const theme = createTheme({
    settings: {
        background: '#F5F6F9',
        caret: '#000',
        fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
        fontSize: '14px',
        foreground: '#14171F',
        gutterActiveForeground: '#F5F6F9',
        gutterBackground: '#F5F6F9',
        gutterBorder: '#F5F6F9',
        gutterForeground: '#F5F6F9',
        lineHighlight: '#E5E7EB',
        selection: '#D7E3FC',
        selectionMatch: '#BAE5C8',
    },
    styles: [
        {
            color: '#1650CF',
            tag: [
                t.keyword,
                t.operatorKeyword,
                t.modifier,
                t.color,
                t.constant(t.name),
                t.standard(t.name),
                t.standard(t.tagName),
                t.special(t.brace),
                t.atom,
                t.bool,
                t.special(t.variableName),
            ],
        },
        { color: '#CD74DD', tag: [t.moduleKeyword, t.controlKeyword] },
        {
            color: '#2464E7',
            tag: [
                t.name,
                t.deleted,
                t.character,
                t.macroName,
                t.propertyName,
                t.variableName,
                t.labelName,
                t.definition(t.name),
            ],
        },
        { color: '#2464E7', fontWeight: 'bold', tag: t.heading },
        {
            color: '#307F4A',
            tag: [
                t.typeName,
                t.className,
                t.tagName,
                t.number,
                t.changed,
                t.annotation,
                t.self,
                t.namespace,
            ],
        },
        {
            color: '#B42318',
            tag: [t.function(t.variableName), t.function(t.propertyName)],
        },
        { color: '#307F4A', tag: [t.number] },
        {
            color: '#14171F',
            tag: [t.operator, t.punctuation, t.separator, t.url, t.escape, t.regexp],
        },
        { color: '#CD74DD', tag: [t.regexp] },
        {
            color: '#7A271A',
            tag: [t.special(t.string), t.processingInstruction, t.string, t.inserted],
        },
        { color: '#14171F', tag: [t.angleBracket] },
        { fontWeight: 'bold', tag: t.strong },
        { fontStyle: 'italic', tag: t.emphasis },
        { tag: t.strikethrough, textDecoration: 'line-through' },
        { color: '#677084', tag: [t.meta, t.comment] },
        { color: '#2464E7', tag: t.link, textDecoration: 'underline' },
        { color: '#F04438', tag: t.invalid },
    ],
    theme: 'light',
});
//# sourceMappingURL=theme.js.map